__turbopack_context__.v({
  "buttonRows": "_0mx2Ka_buttonRows",
  "buttonRowsWrapper": "_0mx2Ka_buttonRowsWrapper",
  "cardImgContainer": "_0mx2Ka_cardImgContainer",
  "cardTextContent": "_0mx2Ka_cardTextContent",
  "content": "_0mx2Ka_content",
  "fadeIn": "_0mx2Ka_fadeIn",
  "featuresContainer": "_0mx2Ka_featuresContainer",
  "root": "_0mx2Ka_root",
  "styledCapability": "_0mx2Ka_styledCapability",
  "text": "_0mx2Ka_text",
});
